<template>
  <section class="promotions">
    <h2 class="section-title">最新優惠活動</h2>
    <div class="promotion-list">
      <div v-for="promo in promotions" :key="promo.date" class="promotion-item" @click="goPromotionDetail(promo)">
        <div class="promotion-info">
          <span class="item-text-bold">{{ formatISODateToCustom(promo.updated_at) }}</span>
          <div class="promotion-title item-text-bold">{{ promo.title }}</div>
          <!-- <div class="promotion-title item-text-bold">sjfadkfjlksdfjkldsjfksldjfkldsjlk</div> -->
        </div>
        <img :src="getFullImageURL(promo.offer_image)" :alt="promo.title" class="promotion-image" @error="onImageError">
      </div>
    </div>
    <button class="more-btn" @click="goAllPromotions">更多優惠活動</button>
  </section>
</template>
<script>
import { onImageError, getFullImageURL, formatISODateToCustom } from '@/util/util';
import PullDAO from '@/services/PullDAO';
import { globalParams } from '@/global';

export default {
  name: 'PromotionsList',
  data() {
    return {
      promotions: [],
      isLoading: false,
      error: null,
      row: 3, // Number of offers per page
      page: 1  // Current page
    };
  },
  methods: {
    formatISODateToCustom,
    onImageError,
    getFullImageURL,

    async fetchOffers() {
      this.isLoading = true;
      this.error = null;

      const pullDAO = new PullDAO();

      try {
        const resp = await pullDAO.listOffers(this.row, this.page);
        // Assuming each offer has a unique 'id'. If not, use another unique field.
        this.promotions = [...this.promotions, ...resp.offers];
      } catch (err) {
        this.error = err.message || '無法加載優惠活動。';
      } finally {
        this.isLoading = false;
      }
    },

    goPromotionDetail(promo) {
      globalParams.shownPromotion = promo;
      this.$router.push("/promotion-detail");
    },
    goAllPromotions() {
      this.$router.push({ name: 'AllPromotions' });
    },
    loadMore() {
      this.page += 1;
      this.fetchOffers();
    }
  },
  mounted() {
    this.fetchOffers();

  }
};
</script>
<style scoped>
.promotions {
  margin: 0 auto;
  padding: 0;
  text-align: center;
  width: var(--home-component-width);
}

.promotion-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

.promotion-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 34px 30px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
}

.promotion-info {
  display: flex;
  align-items: center;
  gap: 40px;
  flex-grow: 1;
}

.item-text-bold {
  /* font-weight: bold; */
  margin: 0px;
  margin-left: 34px;
}

.promotion-title {
  color: var(--gray15);
  /* text-wrap: w; */

}

.promotion-date {
  color: #008000;
  font-weight: bold;
  font-size: calc(1rem + 0.2vw);
  /* Responsive font size */
}

.promotion-image {
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 20px;
  margin-left: 20px;
}

/* Responsive styles */
@media (max-width: 560px) {
  .promotions {
    width: 343px;
  }

  .promotion-list {
    gap: 15px;
  }

  .promotion-item {
    padding: 26px 24px;
  }

  .item-text-bold {
    margin-left: 0px;
  }

  .promotion-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    height: 72px;
  }

  .promotion-title {
    /* white-space: normal; */
    /* Allows text to wrap */
    width: 222px;
    text-align: left;

    white-space: nowrap;
    /* Prevent text from wrapping */
    overflow: hidden;
    /* Hide overflow text */
    text-overflow: ellipsis;
    /* Show ellipsis (...) for overflow text */

    /* Breaks words when necessary */
  }

  .promotion-image {
    width: 72px;
    height: 72px;
    margin-left: 15px;
  }
}
</style>
